<template>
  <AppLoader>
    <AppLoaderLogoSvg aria-hidden="true" class="grayscale" />
  </AppLoader>
</template>
